import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from 'src/app/services/auth/auth.service';
import {RouterSegments} from 'src/app/models/router-segments';
import {SidenavService} from '../../../services/util/sidenav.service';
import {ContactUsDialogComponent} from '../../../layout/toolbar/contact-us-dialog/contact-us-dialog.component';

@Component({
    selector: 'app-not-found-error',
    templateUrl: './not-found-error.html',
    styleUrls: ['./not-found-error.scss'],
    standalone: false
})
export class NotFoundErrorComponent implements OnInit {

  tenant: string;
  RouterSegments = RouterSegments;

  constructor(private router: Router, private sideNav: SidenavService, private authService: AuthService) {
  }

  ngOnInit() {
    this.tenant = this.authService.principal.provider;
  }

  goBack() {
    if (window.history.length > 4) {
      window.history.go(-2);
    } else {
      this.router.navigate(['/' + this.tenant]);
    }
  }

  openContactForm() {
    this.sideNav.openInRightSidenav(ContactUsDialogComponent);
  }

}
